import React, { FC, memo, ReactNode, useCallback, useMemo, useState } from 'react';
import { BoxesRevenueTable } from './BoxesRevenueTable';
import { TableFilterContextProvider } from 'features/TableFilter';
import { ReactComponent as BoxIcon } from 'shared/assets/icons/BoxTabIcon.svg';
import { ReactComponent as WarehouseIcon } from 'shared/assets/icons/WarehouseIcon.svg';
import { TabSwitcher } from 'shared/ui/TabSwitcher';
import { ExportModal } from 'features/ExportModal';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { WarehousesRevenue } from './WarehousesRevenue';

export const BoxesRevenuePage: FC = memo(() => {
  const { t } = useAppTranslation(['contracts', 'common']);

  const [selectedTabKey, setSelectedTabKey] = useState('Warehouses');

  const renderTabContent = useCallback((): Nullable<ReactNode> => {
    switch (selectedTabKey) {
      case 'Warehouses':
        return (
          <TableFilterContextProvider>
            <WarehousesRevenue />
          </TableFilterContextProvider>
        );
      case 'Boxes':
        return (
          <TableFilterContextProvider>
            <BoxesRevenueTable />
          </TableFilterContextProvider>
        );

      default:
        return null;
    }
  }, [selectedTabKey]);

  const switchTab = useCallback((tabKey: string): void => {
    setSelectedTabKey(tabKey);
  }, []);

  const tabs = useMemo(() => {
    const commonTabs = [
      { key: 'Warehouses', label: t('Warehouses'), icon: <WarehouseIcon /> },
      { key: 'Boxes', label: t('Boxes'), icon: <BoxIcon /> },
    ];

    return commonTabs;
  }, [t]);

  return (
    <TabSwitcher tabs={tabs} selectedTabKey={selectedTabKey} onChangeTab={switchTab}>
      {renderTabContent()}
      <ExportModal />
    </TabSwitcher>
  );
});
